"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getCounterFromLocalStorage = () => {
  let counter = 0;
  let value = localStorage.getItem("mco-shop-cart");
  if (!value) return counter;
  value = JSON.parse(value);
  const {
    items = []
  } = value;
  for (const item of items) {
    const {
      quantity = 1
    } = item;
    counter += quantity !== null && quantity !== void 0 ? quantity : 0;
  }
  return counter;
};
var _default = exports.default = getCounterFromLocalStorage;